import React from 'react';
import { Heading } from '@beef/legacy-ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import TagButton from 'bricks/TagButton';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const TagButtonList = ({ headline, headlineTagName, isMobile, list }) => {
  return (
    <div className={cx('component')}>
      {headline ?
        <Heading
          className={cx('heading', isMobile ? 'headingMobile' : '')}
          tagName={headlineTagName}
        >
          {headline}
        </Heading>
      : null}

      {list.map(({ isActive, title, url }, index) => (
        <TagButton href={isActive ? '' : url} isActive={isActive} key={+index}>
          {title}
        </TagButton>
      ))}
    </div>
  );
};

TagButtonList.propTypes = {
  headline: PropTypes.string,
  headlineTagName: PropTypes.string,
  isMobile: PropTypes.bool,
  list: PropTypes.array,
};

TagButtonList.defaultProps = {
  headline: '',
  headlineTagName: 'div',
  isMobile: false,
  list: [],
};

export default TagButtonList;
